import { useTranslation } from 'react-i18next';
import { MessageCircle } from 'lucide-react';
import { useWorkspace } from '@/workspace/WorkspaceContext';
import { Badge } from '@/components/ui/badge';
import { WidgetTab } from '@/components/organization/WidgetTab';

export function Widget(): JSX.Element {
  const { t } = useTranslation();
  const { currentBotId, currentBot } = useWorkspace();

  if (!currentBotId) {
    return (
      <div className="rounded-md border border-dashed p-8 text-center text-sm text-muted-foreground">
        {t('widgetPage.selectBot', {
          defaultValue: 'Select a bot from the workspace switcher to configure its widget.',
        })}
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <header className="flex items-center gap-3">
        <MessageCircle className="h-6 w-6 text-primary" />
        <div>
          <h1 className="text-2xl font-semibold">
            {t('widgetPage.title', { defaultValue: 'Widget' })}
          </h1>
          <p className="text-xs text-muted-foreground">
            {t('widgetPage.subtitle', {
              defaultValue:
                'Embeddable chatbot for {{bot}}. Each bot has its own activation, allowed origins, theme and keys.',
              bot: currentBot?.name ?? currentBotId,
            })}
          </p>
        </div>
        {currentBot ? (
          <Badge variant="secondary" className="ml-auto font-mono">
            {currentBotId}
          </Badge>
        ) : null}
      </header>
      <WidgetTab />
    </div>
  );
}
